var _defs, _polygon, _path, _polygon2, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path3, _path4, _path5, _path6, _path7, _ellipse9, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _path8, _path9, _path10, _polygon21, _path11, _polygon22, _path12, _path13, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _path14, _path15, _g, _path16, _g2, _path17, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 503.63 517.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 259.88,
    y1: 802.5,
    x2: 259.88,
    y2: 542.97,
    gradientTransform: "translate(0 -309.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2,49.7V172.5a10.86,10.86,0,0,1-.4,2.5l-.6,1.5a9.06,9.06,0,0,1-3.3,3.7L117.6,275.5a3.05,3.05,0,0,1-3.3.2,2.7,2.7,0,0,1-.7-.8,4.06,4.06,0,0,1-.4-1.9V150.2a10,10,0,0,1,.4-2.4l.6-1.5a9.06,9.06,0,0,1,3.3-3.7L282.8,47.2h0a3.05,3.05,0,0,1,3.3-.2,2.7,2.7,0,0,1,.7.8A4.06,4.06,0,0,1,287.2,49.7Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6,248.9v49.4a3.55,3.55,0,0,1-.2,1,1.42,1.42,0,0,0-.2.6,4.71,4.71,0,0,1-1.3,1.5L4.4,339.8a1.23,1.23,0,0,1-1.3.1l-.3-.3a1.88,1.88,0,0,1-.2-.8V289.4a3.55,3.55,0,0,1,.2-1,4.12,4.12,0,0,1,1.6-2.1l66.5-38.4h0a1.23,1.23,0,0,1,1.3-.1l.3.3A2.2,2.2,0,0,1,72.6,248.9Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "407.9 99.6 449.9 122.8 449.9 171.3 407.9 148 407.9 99.6",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.6 45.3 177.1 57.8 177.1 83.9 199.6 71.4 199.6 45.3",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(1.6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "53.6 266.3 24.6 282.3 24.6 315.7 53.6 299.7 53.6 266.3",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "501.1 323.6 501.1 312.5 490.4 319.4 501.1 323.6",
    fill: "#b1b4c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,502.1l-124.7-72c-10.6-6.1-9.2-16.8,3-23.8L329,232.5c12.2-7,30.6-7.8,41.2-1.7l124.7,72c10.6,6.1,9.2,16.7-3,23.8L190.8,500.3C178.6,507.4,160.1,508.2,149.6,502.1Z",
    transform: "translate(1.6)",
    fill: "#d6d8e5",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.1,513,22.4,441c-10.6-6.1-9.2-16.7,3-23.8L326.5,243.4c12.2-7,30.6-7.8,41.2-1.7l124.7,72c10.6,6.1,9.2,16.8-3,23.8L188.3,511.3C176.1,518.3,157.6,519.1,147.1,513Z",
    transform: "translate(1.6)",
    fill: "#b1b4c4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.9 430.5 16.9 419 30.3 424.1 16.9 430.5",
    fill: "#b1b4c4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1,503.3l-124.7-72c-10.6-6.1-9.2-16.8,3-23.8L326.5,233.7c12.2-7,30.6-7.8,41.2-1.7l124.7,72c10.6,6.1,9.2,16.7-3,23.8L188.3,501.6C176.1,508.6,157.6,509.4,147.1,503.3Z",
    transform: "translate(1.6)",
    fill: "#616e84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.45,
    cy: 443.94,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-215.49 77.71) rotate(-30)",
    fill: "#757b89"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.45,
    cy: 447.44,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-216.44 81.18) rotate(-30)",
    fill: "#757b89"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.42,
    cy: 450.8,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-217.31 84.61) rotate(-30)",
    fill: "#757b89"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.45,
    cy: 454.34,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-218.28 88.1) rotate(-30)",
    fill: "#757b89"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.95,
    cy: 484.14,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-226.28 117.84) rotate(-30)",
    fill: "#757b89"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.95,
    cy: 487.54,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-227.17 121.3) rotate(-30)",
    fill: "#757b89"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.95,
    cy: 491.04,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-228.12 124.77) rotate(-30)",
    fill: "#757b89"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.95,
    cy: 494.54,
    rx: 1.3,
    ry: 2.3,
    transform: "translate(-229.07 128.24) rotate(-30)",
    fill: "#757b89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3,476.6l-16.5-9.5a4.37,4.37,0,0,1-1.9-3.6h0c0-1.4.8-2,1.9-1.4l16.5,9.5a4.37,4.37,0,0,1,1.9,3.6h0C90.2,476.5,89.4,477.2,88.3,476.6Z",
    transform: "translate(1.6)",
    fill: "#757b89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M461.8,350.9l-15.3,8.9c-1,.6-1.8,0-1.8-1.3h0a4.32,4.32,0,0,1,1.8-3.4l15.3-8.9c1-.6,1.8,0,1.8,1.3h0A5,5,0,0,1,461.8,350.9Z",
    transform: "translate(1.6)",
    fill: "#757b89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3,364.4,423,373.3c-1,.6-1.8,0-1.8-1.3h0a4.32,4.32,0,0,1,1.8-3.4l15.3-8.9c1-.6,1.8,0,1.8,1.3h0A4.3,4.3,0,0,1,438.3,364.4Z",
    transform: "translate(1.6)",
    fill: "#757b89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1,501.5l-124.7-72c-10.6-6.1-9.2-16.7,3-23.8L326.5,231.9c12.2-7,30.6-7.8,41.2-1.7l124.7,72c10.6,6.1,9.2,16.8-3,23.8L188.3,499.8C176.1,506.9,157.6,507.6,147.1,501.5Z",
    transform: "translate(1.6)",
    fill: "#20232d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M479,305l-48.7-28.1-.1.1c-5.8,3.3-15.1,3.3-20.8,0s-5.8-8.7,0-12l.1-.1-48.7-28.1c-7.4-4.3-19.4-4.3-26.8,0L40.8,406.1c-7.4,4.3-7.4,11.2,0,15.5l118.1,68.2c7.4,4.3,19.4,4.3,26.8,0L479,320.5C486.4,316.2,486.4,309.3,479,305Z",
    transform: "translate(1.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M479,320.5,185.7,489.9c-6.7,3.9-17.1,4.2-24.5,1.1a15.05,15.05,0,0,1-2.2-1.1L40.8,421.6a13.21,13.21,0,0,1-4.2-3.6c-2.8-4-1.4-8.6,4.2-11.9L334.1,236.8c7.4-4.3,19.4-4.3,26.8,0l48.7,28.1a.1.1,0,0,0-.1.1c-5.8,3.3-5.8,8.7,0,12s15.1,3.3,20.8,0l.1-.1L479.1,305C486.4,309.3,486.4,316.2,479,320.5Z",
    transform: "translate(1.6)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.2,
    cy: 272.8,
    rx: 5.6,
    ry: 3.2,
    fill: "#2b303f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.9,273.8a1.15,1.15,0,0,1-.7-1.3,1,1,0,0,1,.7-.7,3.82,3.82,0,0,1,3.3,0,1.15,1.15,0,0,1,.7,1.3,1,1,0,0,1-.7.7A3.82,3.82,0,0,1,414.9,273.8Z",
    transform: "translate(1.6)",
    fill: "#fff",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.2 296.1 436.1 294.9 439.6 292.8 441.8 294.1 438.2 296.1",
    fill: "#e9eaf2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.1 297.7 438.9 296.5 443.9 293.6 446 294.9 441.1 297.7",
    fill: "#e9eaf2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "443.9 299.3 441.8 298.1 448.8 294.1 450.9 295.3 443.9 299.3",
    fill: "#e9eaf2"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.7 301 444.6 299.8 454.5 294.1 456.6 295.3 446.7 301",
    fill: "#e9eaf2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.9 306.3 452.6 304.4 459.2 300.6 462.5 302.5 455.9 306.3",
    fill: "#e9eaf2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "460.3 308.8 457 306.9 463.6 303.1 466.9 305 460.3 308.8",
    fill: "#e9eaf2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.7 311.3 461.4 309.4 468 305.6 471.2 307.5 464.7 311.3",
    fill: "#e9eaf2"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "448.5 321.4 436 328.6 316.4 259.6 328.9 252.3 448.5 321.4",
    fill: "#e9eaf2"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.2 341.5 180.8 368.4 154.9 353.5 201.2 326.5 227.2 341.5",
    fill: "#e9eaf2"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "280 346.9 212 386.4 186 371.5 254 331.9 280 346.9",
    fill: "#e9eaf2"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.4 353.7 243.2 404.4 217.2 389.4 304.4 338.8 330.4 353.7",
    fill: "#e9eaf2"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.4 361.9 274.3 422.4 248.4 407.4 352.5 347 378.4 361.9",
    fill: "#e9eaf2"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.6 432.3 245.1 439.6 125.5 370.5 138 363.3 257.6 432.3",
    fill: "#e9eaf2"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.4 445.2 222.9 452.5 103.3 383.4 115.8 376.2 235.4 445.2",
    fill: "#e9eaf2"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.3 458.1 200.8 465.4 81.1 396.3 93.6 389 213.3 458.1",
    fill: "#e9eaf2"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.1 471 178.6 478.3 59 409.2 71.5 401.9 191.1 471",
    fill: "#e9eaf2"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.2 347.2 391.7 354.4 272.1 285.3 284.6 278.1 404.2 347.2",
    fill: "#e9eaf2"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.4 334.3 413.9 341.5 294.2 272.5 306.7 265.2 426.4 334.3",
    fill: "#e9eaf2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M488.1,116.3,384.9,56.7c-2.8-1.6-5.3-1.9-7.3-1h0c-.3.1-.5.3-.8.4l-10.8,6,7.8,11V151c0,7,4.9,15.5,11,19l40.4,23.3,4.9,12.7-5.2,22.5,11.4-6.3,11.2-15.9,35,20.2,1.2,10.5,11.3-6.3c2.3-1,3.8-3.5,3.8-7.4V135.4C499.1,128.3,494.2,119.8,488.1,116.3Z",
    transform: "translate(1.6)",
    fill: "#002f87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M476.7,122.6,373.5,63c-6.1-3.5-11-.7-11,6.3v88c0,7,4.9,15.5,11,19l40.4,23.3,11.2,28.8,11.2-15.9,40.4,23.3c6.1,3.5,11,.7,11-6.3v-88C487.7,134.6,482.8,126.1,476.7,122.6Z",
    transform: "translate(1.6)",
    fill: "#d1def2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M464.1,125.5A11,11,0,0,1,469,134c0,3.1-2.2,4.4-4.9,2.8a11,11,0,0,1-4.9-8.5C459.1,125.2,461.3,123.9,464.1,125.5Z",
    transform: "translate(1.6)",
    fill: "#d6081d"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "453 182.5 453 190.3 393.7 156 393.7 148.3 453 182.5",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M281.8,44.8a1.34,1.34,0,0,0-.6-.7,4.28,4.28,0,0,0-1.6-.5L195.1,19.3,110.7,141.1a10.71,10.71,0,0,0-1.5,2.2,4.71,4.71,0,0,0-.6,1.5,6.72,6.72,0,0,0-.4,2.4V270.1a4.06,4.06,0,0,0,.4,1.9,2.7,2.7,0,0,0,.7.8,3,3,0,0,0,3.3-.1l165.3-95.4a9.94,9.94,0,0,0,3.9-5.1,6.9,6.9,0,0,0,.4-2.5V46.7A5.85,5.85,0,0,0,281.8,44.8Z",
    transform: "translate(1.6)",
    fill: "#ddb545"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.6 43.9 287.8 47 280.5 52.3 282.6 43.9",
    fill: "#ceb95f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.2,19.3l5.1,3.1,85.9,24.7-4.3-2.5a30.52,30.52,0,0,0-5.1-1.7Z",
    transform: "translate(1.6)",
    fill: "#c19b3d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M287.2,49.7V172.5a10.86,10.86,0,0,1-.4,2.5l-.6,1.5a9.06,9.06,0,0,1-3.3,3.7L117.6,275.5a3.05,3.05,0,0,1-3.3.2,2.7,2.7,0,0,1-.7-.8,4.06,4.06,0,0,1-.4-1.9V150.2a10,10,0,0,1,.4-2.4l.6-1.5a9.06,9.06,0,0,1,3.3-3.7L282.8,47.2,280,49.1c1.3-.8,5.3-2.7,6.1-2.1a2.7,2.7,0,0,1,.7.8A3.13,3.13,0,0,1,287.2,49.7Z",
    transform: "translate(1.6)",
    fill: "#ffbd44"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.9 275.7 201.8 160.8 288 176.1 288 188.2 114.8 288.2 115.9 275.7",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.9 146.3 201.8 22.3 287.8 47 201.8 160.8 115.9 146.3",
    fill: "#ffd44d"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "287.8 47 268.3 72.8 201.8 160.8 135.3 149.6 115.9 146.3 135.3 118.2 183.2 49.1 201.8 22.3 220.4 27.6 268.3 41.4 287.8 47",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.3 0 268.3 72.8 201.8 160.8 135.3 149.6 135.3 76.8 268.3 0",
    fill: "#fafbff"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "244 86.6 163.6 133.4 163.6 126.8 244 80 244 86.6",
    fill: "#e9eaf2"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "244 103 163.6 149.8 163.6 143.2 244 96.4 244 103",
    fill: "#e9eaf2"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.8 127.7 175.9 156.1 167.8 155.1 235.3 116.5 226.8 127.7",
    fill: "#e9eaf2"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.7 197.8 457.6 205.6 391.9 167.6 391.9 159.9 457.7 197.8",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70,247.5v49.4a3.55,3.55,0,0,1-.2,1c-.1.2-.1.4-.2.6a4.71,4.71,0,0,1-1.3,1.5L1.8,338.4a1.23,1.23,0,0,1-1.3.1l-.3-.3a1.88,1.88,0,0,1-.2-.8V288a3.55,3.55,0,0,1,.2-1l.3-.6a4.71,4.71,0,0,1,1.3-1.5l66.5-38.4h0a1.23,1.23,0,0,1,1.3-.1l.3.3A2,2,0,0,1,70,247.5Z",
    transform: "translate(1.6)",
    fill: "#ddb545"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6,248.9v49.4a3.55,3.55,0,0,1-.2,1,1.42,1.42,0,0,0-.2.6,4.71,4.71,0,0,1-1.3,1.5L4.4,339.8a1.23,1.23,0,0,1-1.3.1l-.3-.3a1.88,1.88,0,0,1-.2-.8V289.4a3.55,3.55,0,0,1,.2-1,4.12,4.12,0,0,1,1.6-2.1l66.5-38.4h0a1.23,1.23,0,0,1,1.3-.1l.3.3A2.2,2.2,0,0,1,72.6,248.9Z",
    transform: "translate(1.6)",
    fill: "#ffbd44"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.5 340 39.2 293.6 73.9 299.7 73.9 304.6 4.2 344.8 4.5 340",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.2 293.6 4.6 287.9 1.4 286.9 0 343.2 4.6 339.8 39.2 293.6",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.2 293.6 73.9 247.9 77 243.2 78.5 297.9 73.9 299.7 39.2 293.6",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell-solid"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.2,156.4c0,4-3.3,5.5-7.3,3.3s-7.3-7.3-7.3-11.4Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.5,155.8a10,10,0,0,1-4.7-6.3L442,134.1c-.5-5.6-4.2-11.9-9.1-16.2,0-.2.1-.4.1-.6,0-2.2-1.8-4.9-3.9-6.1s-3.9-.4-3.9,1.7a1.27,1.27,0,0,0,.1.6c-4.9-1.2-8.6.9-9.2,5.8l-1.8,13.6c-.5,1.9-2.5,2.3-4.7,1.1l-1.4-.8v5.2l42,23.3v-5.2Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5,48.8a6.07,6.07,0,0,1-2.6,4.6c-1.4.9-2.7.2-2.7-1.5a6.07,6.07,0,0,1,2.6-4.6C200.3,46.4,201.5,47.1,201.5,48.8Z",
    transform: "translate(1.6)",
    fill: "#d6081d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bell-solid-2",
    "data-name": "Bell-solid"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.4,75.9c0,2.2,1.8,3,3.9,1.8a7.74,7.74,0,0,0,3.9-6.1Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.8,75.6a5.33,5.33,0,0,0,2.5-3.4l1-8.3a14.58,14.58,0,0,1,4.9-8.7v-.3a4.22,4.22,0,0,1,2.1-3.3c1.2-.6,2.1-.2,2.1.9v.3c2.6-.7,4.6.5,5,3.1l1,7.3c.3,1,1.3,1.2,2.5.6l.8-.4v2.8L177.1,78.7V76Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57,268.2a7.45,7.45,0,0,1-3.4,5.9c-1.9,1.1-3.4.2-3.4-1.9a7.61,7.61,0,0,1,3.4-5.9C55.5,265.2,57,266,57,268.2Z",
    transform: "translate(1.6)",
    fill: "#d6081d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Bell-solid-3",
    "data-name": "Bell-solid"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1,305.5c0,2.8,2.3,3.8,5,2.2s5-5,5-7.8Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6,305.1a7.67,7.67,0,0,0,3.3-4.4l1.2-10.6c.4-3.8,2.9-8.2,6.3-11.2v-.4a5.37,5.37,0,0,1,2.7-4.2c1.5-.8,2.7-.3,2.7,1.2v.4c3.4-.9,5.9.7,6.4,4l1.3,9.4c.4,1.3,1.7,1.6,3.3.7l1-.6V293l-29,16.1v-3.6Z",
    transform: "translate(1.6)",
    fill: "#002f99"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImage);
export default __webpack_public_path__ + "static/media/PhoneImage.368ad194.svg";
export { ForwardRef as ReactComponent };